<!--banner板塊-->
<template>
  <div class="banner">
    <!-- 半圆样式 -->
    <div class="circle"></div>
    <!-- banner图片 -->
    <div class="banner_pic">
      <img src="@/assets/images/home/banner.png" alt="" class="hidden-md" />
      <img
        src="@/assets/images/home/banner-mobile.png"
        alt=""
        class="visible-md"
      />
    </div>
    <div class="banner_text">WE ARE ORA THEND IS NOT DEFINED</div>
  </div>
</template>

<script>
export default {
  name: "banner",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 770px;
  overflow: hidden;
  position: relative;
  .circle {
    position: absolute;
    left: -211px;
    top: -944px;
    width: 1578px;
    height: 1578px;
    border-radius: 100%;
    background: #e8cca7;
  }
  .banner_pic {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 72%;
    border-radius: 0px 0px 0px 100px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .banner_text {
    position: absolute;
    top: 10%;
    left: 16%;
    width: 930px;
    font-size: 120px;
    font-weight: 600;
    line-height: 110px;
    color: #fff;
    text-align: left;
  }
}

// 1450px
@media screen and (max-width: 1450px) {
  .banner {
    .circle {
      position: absolute;
      left: -155px;
      top: -535px;
      width: 1189px;
      height: 1189px;
      border-radius: 100%;
      background: #e8cca7;
    }
    .banner_text {
      position: absolute;
      top: 20%;
      left: 16%;
      width: 900px;
      font-size: 90px;
      line-height: 90px;
    }
  }
}

// 1200px
@media screen and (max-width: 1200px) {
  .banner {
    .circle {
      position: absolute;
      left: -155px;
      top: -328px;
      width: 984px;
      height: 984px;
      border-radius: 100%;
      background: #e8cca7;
    }
    .banner_text {
      position: absolute;
      top: 30%;
      left: 16%;
      width: 800px;
      font-size: 80px;
      line-height: 80px;
    }
  }
}
// 767px
@media screen and (max-width: 767px) {
  .banner {
    width: 100%;
    height: 618px;
    overflow: hidden;
    position: relative;
    .circle {
      position: absolute;
      left: -311px;
      top: -144px;
      width: 618px;
      height: 618px;
      border-radius: 100%;
      background: #e8cca7;
    }
    .banner_pic {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 86%;
      border-radius: 0px 0px 0px 100px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .banner_text {
      position: absolute;
      top: 25%;
      left: 5%;
      width: 310px;
      font-size: 44px;
      line-height: 44px;
    }
  }
}
</style>